import { PickListUrls } from 'services/api/urls';
import { PickList } from 'types/PickList';
import useApi, { UseApiResult } from 'hooks/useApi';

export default function usePickList(
  objectType: string,
  fieldName?: string | null,
): UseApiResult<PickList> {
  return useApi<PickList>(
    objectType && fieldName ? PickListUrls.GET(objectType, fieldName) : null,
  );
}
